import React from 'react'
import ReactCountryFlag from 'react-country-flag'

export default function CountryFlag({ iso }) {
  return <ReactCountryFlag svg countryCode={iso} style={{ fontSize: '1.3rem' }} />
}
